// columnsConfig.js
export const columnsConfig = {
    moral_bati: [
        { key: 'parcelle', label: 'N°' },
        { key: 'invar', label: 'Invar' },
        { key: 'dnupro', label: 'Dnupro' },
        { key: 'dnuper', label: 'Dnuper' },
        { key: 'ddenom', label: 'Nom' },
        { key: 'nee', label: 'Naissance' },
        { key: 'adresse', label: 'Adresse' },
        { key: 'avis', label: 'Avis impos.' },
        { key: 'dteloc_lib', label: 'Nature' },
        { key: 'surface', label: 'Surface' },
        { key: 'valeur_locative_an', label: 'Valeur locative (An)' },
    ],
    moral_nonbati: [
        { key: 'lieux', label: 'Lieux' },
        { key: 'parcelle', label: 'Parcelle' },
        { key: 'surface_geo', label: 'Surface (m²)' },
        { key: 'dnupro', label: 'Dnupro' },
        { key: 'dnuper', label: 'Dnuper' },
        { key: 'personne', label: 'Personne' },
        { key: 'ddenom', label: 'Propriétaire' },
        { key: 'adresse', label: 'Adresse' },
        { key: 'avis', label: '	Avis impos.' },
        { key: 'parcelle_batie', label: 'Parcelle bâtie' },
    ],
    physique_bati: [
        { key: 'parcelle', label: 'N°' },
        { key: 'invar', label: 'Invar' },
        { key: 'dnupro', label: 'Dnupro' },
        { key: 'dnuper', label: 'Dnuper' },
        { key: 'ddenom', label: 'Nom' },
        { key: 'nee', label: 'Naissance' },
        { key: 'adresse', label: 'Adresse' },
        { key: 'avis', label: 'Avis impos.' },
        { key: 'dteloc_lib', label: 'Nature' },
        { key: 'surface', label: 'Surface' },
        { key: 'valeur_locative_an', label: 'Valeur locative (An)' },
    ],
    physique_nonbati: [
        { key: 'parcelle', label: 'Parcelle' },
        { key: 'invar', label: 'Invar' },
        { key: 'dnupro', label: 'Dnupro' },
        { key: 'dnuper', label: 'Dnuper' },
        { key: 'jdatat', label: 'Date acte' },
        { key: 'supf', label: 'Surface' },
        { key: 'nee', label: 'Née' },
    ],
    indivi: [
        { key: 'id_insee', label: 'Insee' },
        { key: 'parcelle', label: 'Parcelle' },
        { key: 'cconlo_lib', label: 'Lots' },
        { key: 'dnulot', label: 'Lots n°' },
        { key: 'dnupro', label: 'Dnupro' },
        { key: 'dnuper', label: 'Dnuper' },
        { key: 'ddenom', label: 'Nom indivision' },
        { key: 'nee', label: 'Née' },
        { key: 'adresse', label: 'Adresse' },
        { key: 'date_acte', label: 'Date mutation' },
        { key: 'dcntlo', label: 'Lots Surface' },
        { key: 'indivi', label: 'Indivision' },
    ],
    cpte_comm: [
        { key: 'parcelle', label: 'Parcelle' },
        { key: 'comptecommunal', label: 'Compte N°' },
        { key: 'section', label: 'Section' },
        { key: 'contenance', label: 'Surface (CA)' },
        { key: 'surface', label: 'Surface (m²)' },
        { key: 'proprietaire', label: 'Propriétaire' },
        { key: 'adresse', label: 'Adresse Propriétaire' },
        { key: 'parcelle_batie', label: 'Bâtie' },
        { key: 'lieu_dit', label: 'Lieu-dit' },
        { key: 'code', label: 'Code' },
        { key: 'voie', label: 'Voie N°' },
    ],
    fonc_resid_zu: [
        { key: 'parcelle', label: 'Parcelle' },
        { key: 'section', label: 'Section' },
        { key: 'numero', label: 'Numéro' },
        { key: 'contenance', label: 'Contenance' },
        { key: 'surface_parcelle', label: 'Surface (m²)' },
        { key: 'typezone', label: 'Zone' },
        { key: 'secteur', label: 'Secteur' },
        { key: 'libelle', label: 'Libellé' },
        { key: 'surface_m', label: 'Surf.' },
    ],
    fonc_resid_zu_uf: [
        { key: 'parcelle', label: 'Parcelle' },
        { key: 'section', label: 'Section' },
        { key: 'numero', label: 'Numéro' },
        { key: 'contenance', label: 'Contenance' },
        { key: 'surface_parcelle', label: 'Surface (m²)' },
        { key: 'typezone', label: 'Zone' },
        { key: 'secteur', label: 'Secteur' },
        { key: 'libelle', label: 'Libellé' },
        { key: 'surface_m', label: 'Surf.' },
    ],
    fonc_resid_a: [
        { key: 'parcelle', label: 'Parcelle' },
        { key: 'section', label: 'Section' },
        { key: 'numero', label: 'Numéro' },
        { key: 'contenance', label: 'Contenance' },
        { key: 'surface_parcelle', label: 'Surface (m²)' },
        { key: 'typezone', label: 'Zone' },
        { key: 'secteur', label: 'Secteur' },
        { key: 'libelle', label: 'Libellé' },
        { key: 'surface_m', label: 'Surf.' },
    ],
    non_bati_a_uf: [
        { key: 'id', label: 'Parcelle' },
        { key: 'section', label: 'Section' },
        { key: 'numero', label: 'Numéro' },
        { key: 'contenance', label: 'Contenance' },
        { key: 'surface_parcelle', label: 'Surface (m²)' },
        { key: 'bati', label: 'Bâti' },
        { key: 'typezone', label: 'Zone' },
        { key: 'secteur', label: 'Secteur' },
        { key: 'libelle', label: 'Libellé' },
        { key: 'surface_libelle', label: 'Libellé (m²)' },
    ],
    prop_pers_morale: [
        { key: 'parcelle', label: 'Parcelle N°' },
        { key: 'section', label: 'Section' },
        { key: 'numero', label: 'Numéro' },
        { key: 'contenance', label: 'Contenance' },
        { key: 'prop_majic_n', label: 'Prop N°' },
        { key: 'prop_siren', label: 'Siren' },
        { key: 'prop_droit', label: 'Prop code' },
        { key: 'prop_type', label: 'Prop type' },
        { key: 'prop_forme_abregee', label: 'Forme abrégée' },
        { key: 'prop_forme', label: 'Forme juridique' },
        { key: 'prop_denomination', label: 'Voie N°' },
        { key: 'voie_rivoli', label: 'Rivoli N°' },
        { key: 'voie_nom', label: 'Voie Nom' },
        { key: 'id_insee', label: 'Insee' },

    ],
    non_bati_zu: [
        { key: 'id', label: 'Parcelle N°' },
        { key: 'section', label: 'Section' },
        { key: 'numero', label: 'Numéro' },
        { key: 'contenance', label: 'Contenance' },
        { key: 'surface_parcelle', label: 'Surface (m²)' },
        { key: 'typezone', label: 'Zone' },
        { key: 'bati', label: 'Bâti' },
        { key: 'secteur', label: 'Secteur' },
        { key: 'libelle', label: 'Libellé' },
        { key: 'surface_libelle', label: 'Libellé (m²)' },

    ],
    parc_zone_a: [
        { key: 'id', label: 'Parcelle' },
        { key: 'section', label: 'Section' },
        { key: 'numero', label: 'Numéro' },
        { key: 'contenance', label: 'Contenance' },
        { key: 'surface_parcelle', label: 'Surface (m²)' },
        { key: 'bati', label: 'Bâti' },
        { key: 'typezone', label: 'Zone' },
        { key: 'libelle', label: 'Libellé' },
        { key: 'surface_m', label: 'Surf.' },
        { key: 'secteur', label: 'Secteur' },
        { key: 'libelong', label: 'libelong' },
        { key: 'id_insee', label: 'Insee' },
    ],
    zone_urba: [
        { key: 'idurba', label: 'Idurba' },
        { key: 'secteur', label: 'Secteur' },
        { key: 'libelle', label: 'Zone' },
        { key: 'libelong', label: 'Définition' },
        { key: 'formdomi', label: 'Forme' },
        { key: 'destoui', label: 'Autorisation' },
        { key: 'typezone', label: 'Sous-condition' },
        { key: 'datvalid', label: 'datvalid' },
        { key: 'id_insee', label: 'Insee' },
    ],
    urba_presc_surf: [
        { key: 'idurba', label: 'Idurba' },
        { key: 'typepsc', label: 'Type' },
        { key: 'stypepsc', label: 'Sous-type' },
        { key: 'Libelle_1', label: 'Prescription' },
        { key: 'txt', label: 'Text' },
        { key: 'libelle_2', label: 'Libelle' },
        { key: 'datvalid', label: 'datvalid' },
        { key: 'id_insee', label: 'Insee' },
    ],
    permis_pa: [
        { key: 'parcelle', label: 'Parcelle' },
        { key: 'type_dau', label: 'Permis' },
        { key: 'num_pa', label: 'Dossier N°' },
        { key: 'etat_pa', label: 'Etat' },
        { key: 'date_reelle_autorisation', label: 'Date debut' },
        { key: 'date_reelle_doc', label: 'Date ouverture' },
        { key: 'date_reelle_daact', label: 'Date fin' },
        { key: 'an_depot', label: 'Dépôt Année' },
        { key: 'denom_dem', label: 'Nom dépôt' },
        { key: 'rec_archi', label: 'Archi.' },
        { key: 'dcp_prem', label: 'Date Sitadel' },
        { key: 'dcp_aut', label: 'Date Autorisation' },
        { key: 'dcp_doc', label: 'Date Ouverture' },
        { key: 'superficie_terrain', label: 'Terrain Surf' },
        { key: 'adr_libvoie_ter', label: 'Adresse ' },
    ],
    permis_loc: [
        { key: 'parcelle', label: 'Parcelle' },
        { key: 'type_dau', label: 'Permis' },
        { key: 'num_dau', label: 'Dossier N°' },
        { key: 'etat_dau', label: 'Etat' },
        { key: 'date_reelle_autorisation', label: 'Date debut' },
        { key: 'date_reelle_doc', label: 'Date ouverture' },
        { key: 'date_reelle_daact', label: 'Date fin' },
        { key: 'nature_projet_declaree', label: 'Nature' },
        { key: 'destination_principale', label: 'Destination' },
        { key: 'type_princip_logts_crees', label: 'Logement' },
        { key: 'nb_niv_max', label: 'Niveau' },
        { key: 'surf_hab_avant', label: 'suf_hab_avant' },
        { key: 'surf_hab_creee', label: 'suf_hab_cree' },
        { key: 'surf_loc_avant', label: 'suf_loc_avant' },
        { key: 'surf_loc_creee', label: 'suf_loc_cree' },
        { key: 'surf_com_avant', label: 'suf_com_avant' },
        { key: 'surf_com_creee', label: 'suf_com_cree' },
        { key: 'surf_agr_avant', label: 'suf_agr_avant' },
        { key: 'surf_agr_creee', label: 'suf_agr_cree' },
    ],
    permis_dp: [
        { key: 'parcelle', label: 'Parcelle' },
        { key: 'type_dau', label: 'Permis' },
        { key: 'num_dau', label: 'Dossier N°' },
        { key: 'etat_dau', label: 'Etat' },
        { key: 'date_reelle_autorisation', label: 'Date debut' },
        { key: 'date_reelle_doc', label: 'Date ouverture' },
        { key: 'date_reelle_daact', label: 'Date fin' },
        { key: 'cat_dem', label: 'Catégorie' },
        { key: 'denom_dem', label: 'Nom dépôt' },
        { key: 'rec_archi', label: 'Archi.' },
        { key: 'nature_projet_declaree', label: 'Nature' },
        { key: 'destination_principale', label: 'Destination' },
        { key: 'type_princip_logts_crees', label: 'Logement' },
        { key: 'res_princip_ou_second', label: 'Résidence' },
        { key: 'nb_lgt_tot_crees', label: 'Nb Logement' },
        { key: 'nb_lgt_pret_loc_social', label: 'Nb Log social' },
        { key: 'nb_niv_max', label: 'Nb niveau' },
        { key: 'surf_hab_creee', label: 'Surface totale ' },
    ],
    permis_pc: [
        { key: 'parcelle', label: 'Parcelle' },
        { key: 'type_dau', label: 'Permis' },
        { key: 'num_dau', label: 'Dossier N°' },
        { key: 'etat_dau', label: 'Etat' },
        { key: 'date_reelle_autorisation', label: 'Date debut' },
        { key: 'date_reelle_doc', label: 'Date ouverture' },
        { key: 'date_reelle_daact', label: 'Date fin' },
        { key: 'cat_dem', label: 'Catégorie' },
        { key: 'denom_dem', label: 'Nom dépôt' },
        { key: 'rec_archi', label: 'Archi.' },
        { key: 'nature_projet_declaree', label: 'Nature' },
        { key: 'destination_principale', label: 'Destination' },
        { key: 'type_princip_logts_crees', label: 'Logement' },
        { key: 'res_princip_ou_second', label: 'Résidence' },
        { key: 'nb_lgt_tot_crees', label: 'Nb Logement' },
        { key: 'nb_lgt_pret_loc_social', label: 'Nb Log social' },
        { key: 'nb_niv_max', label: 'Nb niveau' },
        { key: 'surf_hab_creee', label: 'Surface totale ' },
    ],

    // Add other propTypes as needed
};
